<template>
  <el-row class="btm-action">
    <el-pagination
      v-if="count > 0"
      background
      class="pagination"
      :page-size="size"
      :layout="layout"
      :total="count"
      :current-page="pageNo"
      :page-sizes="[10, 20, 30, 40, 50]"
      @size-change="onChangeSize"
      @current-change="onChangeCurrentPage">
    </el-pagination>
  </el-row>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    size: {
      type: Number,
      default: 20
    },
    count: {
      type: Number,
      default: 0
    },
    pageNo: {
      type: Number,
      default: 1
    },
    editSize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    layout () {
      if (this.editSize) {
        return 'total, sizes, prev, pager, next, jumper'
      } else {
        return 'total, prev, pager, next, jumper'
      }
    }
  },
  methods: {
    onChangeCurrentPage (page) {
      this.$emit('changePage', page)
    },
    onChangeSize (size) {
      this.$emit('changeSize', size)
    }
  }
}
</script>

<style scoped>
  .btm-action {
    margin-top: 20px;
    text-align: center;
  }
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background: #F0F2F7;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: var(--main-color);
}
</style>
